import { render, staticRenderFns } from "./createTraineesFeedback.vue?vue&type=template&id=9880b53e&scoped=true"
import script from "./createTraineesFeedback.vue?vue&type=script&lang=js"
export * from "./createTraineesFeedback.vue?vue&type=script&lang=js"
import style0 from "./createTraineesFeedback.vue?vue&type=style&index=0&id=9880b53e&prod&scoped=true&lang=css"
import style1 from "./createTraineesFeedback.vue?vue&type=style&index=1&id=9880b53e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9880b53e",
  null
  
)

export default component.exports